import { SpaceDelimiterParser } from './space-delimiter-parser';
import { GenericParser } from './generic-parser';
import { ImportParser } from './import-parser.interface';
import { EditableDataField } from '../../../common/filter/editable-data-field';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function create(delimiter: string, columns: EditableDataField[]): ImportParser {
    if (delimiter === ' ') {
        return new SpaceDelimiterParser();
    }

    return new GenericParser(delimiter, columns);
}
